module.exports = __webpack_public_path__ + "static/media/Adding_SCF_and_TF.fdca35fc.mp4";